import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import routes from 'constants/routes';
import { AppDispatch } from 'redux/store';
import { deleteGroupById } from 'redux/slices/announcements/announcementGroupSlice';
import Table, { Column } from 'components/Common/StyledTable';
import DeleteModal from 'components/Common/DeleteModal';

const AnnouncementGroupColumns: Column[] = [
    { id: 'title', label: 'Title' },
    { id: 'totalParticipants', label: 'Participants', align: 'center' },
];

function AnnouncementGroupContainer({ data, loading }: any) {
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [group, setGroup] = useState<any>(null);

    const navigationHandler = (row: any) => {
        navigate(routes.announcements.groupDetails.replace(':id', row?.id?.toString()));
    };

    const handleDeleteClick = useCallback((group: any) => {
        setOpenDeleteModal(true);
        setGroup(group);
    }, []);

    const deleteGroup = useCallback(async () => {
        setDeleteLoading(true);
        const { payload }: any = await dispatch(deleteGroupById(group?.id));
        setDeleteLoading(false);
        if (payload?.code === 200) {
            setOpenDeleteModal(false);
        }
    }, [dispatch, group?.id]);

    return (
        <>
            <Table
                unStyled
                navigationHandler={navigationHandler}
                showDeleteCell
                onDeleteClick={handleDeleteClick}
                columns={AnnouncementGroupColumns}
                data={data}
                totalCount={data?.length}
                loading={loading}
            />
            <DeleteModal
                isOpen={openDeleteModal}
                title="Delete Group"
                description="Are you sure you want to delete the selected group!"
                onClose={() => setOpenDeleteModal(false)}
                onDelete={deleteGroup}
                loading={deleteLoading}
            />
        </>
    );
}

export default AnnouncementGroupContainer;
